import apiURL from'./apiURL';

const Types = {
    SHIFTS_UPDATE_SHIFT: "SHIFTS_UPDATE_SHIFT",
};

const updateShift = (field, data) => ({
    type: Types.SHIFTS_UPDATE_SHIFT,
    field,
    data
  });

const Actions = {
  updateShift,
}

export {Types, Actions}